<div class="actions">
  @if (!isDone) {
    <button class="link-btn" (click)="exit.emit()">
      <img [attr.alt]="'imgAlt.backArrow' | translate" src="assets/images/back-arrow.svg" />
      {{ (isFirstStep ? 'pages.service.exit' : 'pages.service.back') | translate }}
    </button>
    @if (!isNew) {
      <button class="secondary" [disabled]="isLoading" (click)="onDeleteDraft()">
        {{ 'pages.service.deleteDraft' | translate }}
      </button>
    }
  }
  @if (!isLastStep && showSaveDraft) {
    <button class="secondary" [disabled]="isLoading" (click)="saveDraft.emit()">
      {{ 'pages.service.saveDraft' | translate }}
    </button>
  }

  @if (!isDone && showSubmit) {
    <button class="primary" [disabled]="isLoading" (click)="onSubmit()">
      {{ (isLastStep ? 'pages.service.submit' : 'pages.service.continue') | translate }}
    </button>
  }
</div>
